module.exports = __webpack_public_path__ + "img/338.fb03c9a.png";